import React, { FC } from 'react'
import { Component } from '../../types/ContentStructure'
import { Box, Grid, Link } from '@mui/material'
import ComponentType from './ComponentType'

interface ISectionFooterProps {
    component: Component
}

const SectionFooter: FC<ISectionFooterProps> = ({ component }) => {
    const { theme, title, image, link, components } = component;

    // Detectar si todos los hijos son LINKs con ícono (sección RRSS)
    const isIconRow = components.length > 0 &&
        components.every((c: Component) =>
            c.componentType.name === 'LINK' &&
            c.icon?.startsWith('http')
        );
    return (
        <Grid
            item
            lg={3} sm={6} xs={12}
            sx={[
                theme.themeStyles,
                {
                    pt: { xs: 4, md: 6 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: { xs: 'center', md: 'flex-start' },
                    textAlign: { xs: 'center', md: 'left' },
                }
            ]}
        >
            {/* Logo de sección (ej: Avantthya logo en col Otros) */}
            {image && (
                <Link href={link ?? '#'} target="_blank" rel="noopener noreferrer" sx={{ mb: 2 }}>
                    <img src={image} alt={title ?? ''} style={{ width: 180, maxHeight: 160, objectFit: 'contain' }} />
                </Link>
            )}

            {/* Título de sección */}
            {title && (
                <Box
                    component="h3"
                    className="Footer_titles"
                    sx={{ m: 0, mb: 2, color: 'inherit' }}
                >
                    {title}
                </Box>
            )}

            {/* Hijos — fila si son íconos RRSS, columna si son links de texto */}
            <Box sx={{
                display: 'flex',
                flexDirection: isIconRow ? 'row' : 'column',
                flexWrap: isIconRow ? 'wrap' : 'nowrap',
                gap: isIconRow ? 1 : 0.5,
                alignItems: isIconRow ? 'center' : { xs: 'center', md: 'flex-start' },
                width: '100%',
            }}>
                {components.map((item: Component, idx: number) => (
                    <ComponentType key={idx} component={item} />
                ))}
            </Box>
        </Grid>
    )
}

export default SectionFooter
